import { ref, reactive, toRefs, computed } from 'vue'
import {
  getPtomMiddlewareCallbackConfig,
  updatePtomMiddlewareCallbackConfig
} from '@/api/ptom.data.model'

export function useGameRuleConfig(proxy) {
  const state = reactive({
    gameRuleDialogVisible: false,
    saveGameRuleConfigLoading: false,
    gameRuleForm: { gameIdList: [] }
  })

  const openGameRuleDialog = async () => {
    try {
      const config = await getPtomMiddlewareCallbackConfig()
      state.gameRuleForm = config || { gameIdList: [] }
      state.gameRuleDialogVisible = true
    } catch (e) {
      console.error(e)
    }
  }

  const saveGameRuleConfig = async () => {
    state.saveGameRuleConfigLoading = true
    try {
      const res = await updatePtomMiddlewareCallbackConfig({ gameIdList: state.gameRuleForm.gameIdList })
      if (res) {
        proxy.$Message.success('配置保存成功')
        state.gameRuleDialogVisible = false
      } else {
        proxy.$Message.error('配置保存失败')
      }
    } catch (e) {
      proxy.$Message.error(e.message || '配置保存失败')
    } finally {
      state.saveGameRuleConfigLoading = false
    }
  }

  return {
    ...toRefs(state),
    openGameRuleDialog,
    saveGameRuleConfig
  }
}
